import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    content: {
      width: '100%',
      flexGrow: 1,
    },
    chartSection: {
      position: 'relative',
      height: 489,
      marginTop: 32,
    },
    legend: {
      textAlign: 'left',
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: variables.richBlack,
      display: 'inline-block',
      marginRight: 10,
    },
    secondDot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      display: 'inline-block',
      marginRight: 10,
    },
    legendTitle: {
      fontWeight: 400,
      fontSize: 12,
      marginRight: 10,
    },
    emptyMessage: {
      color: variables.lineGraphText,
      fontStyle: 'italic',
      margin: '180px 0',
    },
    buttons: {
      marginTop: 20,
      flexDirection: 'row',
      alignItems: 'flex-start',
      alignContent: 'center',

      '@media (max-width: 550px)': {
        flexDirection: 'column',
      },
    },
    secondButton: {
      paddingInlineStart: 24,

      '@media (max-width: 550px)': {
        paddingInlineStart: 0,
        paddingTop: 15,
        width: 260,
      },
    },
    button: {
      color: variables.richBlack,
      fontWeight: 600,
      fontSize: 16,
      marginInlineStart: '0px !important;',
      marginTop: 10,

      '&:hover': {
        backgroundColor: variables.white,
        color: variables.black50,
      },
    },
  }),
);
